import { CategoryButton } from '@/fo/ui/category/button/base';

import { styles } from './CategoryChip.styles';

export interface CategoryChipProps {
  category: CategoryButton;
  onClick?: (id: string) => void;
}

export function CategoryChip({ category, onClick }: CategoryChipProps) {
  const slots = styles();

  const handleClick = () => {
    onClick?.(category.id as string);
  };

  return (
    <button
      className={slots.base({ active: category.active })}
      onClick={handleClick}
    >
      <span
        className={slots.color()}
        style={{ backgroundColor: category.color }}
      />
      <span className={slots.text()}>{category.title}</span>
    </button>
  );
}
